function Card({id, classname, title, children}, props) {
  // Set the background color class
  const backgroundColorClassName = (props.hasOwnProperty('bgc'))?props.bgc:'default';
  const boxShadowClassName = (props.hasOwnProperty('boxshadow'))?props.boxshadow:'';

  const classNameList = buildClassNameList([
    backgroundColorClassName,
    boxShadowClassName
  ])

  return (
    <article id={id} className={classNameList}>
      {title && <CardTitle>{title}</CardTitle>}
      <div className="card-container">
        {children}
      </div>
    </article>
  );
}

function buildClassNameList(cnList) {
  //let classNameList = '';
  let cn = cnList.map((cn) => {
    let rtn = '';
    if (cn.length) {
      rtn = cn;
    }
    return rtn;
  });
  //return classNameList;
  return cn.join(' ');
}

function CardTitle({children}) {
  return (
    <h2 className="card-title">{children}</h2>
  );
}

export {Card, CardTitle}